package org.lennycodes.hldi.backend.db_service

import kotlinx.coroutines.await
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.deleteDoc
import org.lennycodes.hldi.backend.doc

suspend fun deleteEvent(id: String) {

    val eventsCollection = collection(
        FirebaseService.db,
        "events"
    )

    val eventDocument = doc(
        eventsCollection,
        id
    )

    deleteDoc(eventDocument).await()

}